/* eslint-disable no-param-reassign,@typescript-eslint/no-explicit-any */
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const runningFnMap = new Map();
let loginInitReady: Promise<{}> | null = null;

const noParallel = (name: string) => (fn: Function) => (...args: any[]) => {
  const key = name + JSON.stringify(args.slice(1));
  const runningFn = runningFnMap.get(key);
  if (runningFn) {
    return runningFn;
  }
  const val = fn(...args).finally(() => runningFnMap.delete(key));
  runningFnMap.set(key, val);
  return val;
};

interface StateData {
  isLogin: boolean;
  payVip: Record<string, any> | undefined;
  userInfo: Record<string, any> | undefined;
  hasCheckLogin: boolean;
  loginReady: Promise<any> | undefined;
  storage: Record<string, any>;
}

const state: StateData = {
  isLogin: false,
  payVip: undefined,
  userInfo: undefined,
  hasCheckLogin: false,
  loginReady: undefined,
  storage: {},
};

export default new Vuex.Store({
  state,

  getters: {
    payVip: state => state.payVip,
    userInfo: state => state.userInfo,
    hasCheckLogin: state => state.hasCheckLogin,
    storage: state => state.storage,
  },

  mutations: {
    saveLoginReady(state, loginReady) {
      state.loginReady = loginReady;
    },
    saveIsLogin(state, isLogin) {
      state.isLogin = isLogin;
    },
    saveHasCheckLogin(state, hasCheckLogin) {
      state.hasCheckLogin = hasCheckLogin;
    },
    savePayVip(state, payVip) {
      state.payVip = payVip;
    },
    saveUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
    saveStorage(state, data) {
      state.storage = {
        ...state.storage,
        ...data,
      };
    },
  },

  actions: {
    checkLogin: noParallel('checkLogin')(async ({ commit }: Record<any, any>, ...args: any[]) => {
      if (!loginInitReady) {
        loginInitReady = Promise.resolve(Vue.prototype.$magicLogin?.init?.());
      }
      const isLogin = await loginInitReady.then(() => Vue.prototype.$magicLogin?.checkLogin(...args));
      commit('saveIsLogin', isLogin);
      commit('saveHasCheckLogin', true);
      if (!isLogin) {
        commit('saveUserInfo', null);
        commit('savePayVip', null);
      }
      return isLogin;
    }),
    logout: noParallel('logout')(async ({ commit }: Record<any, any>, ...args: any[]) => {
      const logout = await Vue.prototype.$magicLogin?.logout(...args);
      commit('saveIsLogin', false);
      commit('saveUserInfo', null);
      commit('savePayVip', null);
      return logout;
    }),
    getPayVip: noParallel('getPayVip')(async ({ commit }: Record<any, any>, ...args: any[]) => {
      const payVip = await Vue.prototype.$magicLogin?.getPayVip(...args);
      commit('savePayVip', payVip);
      return payVip;
    }),
    getUserInfo: noParallel('getUserInfo')(async ({ commit }: Record<any, any>, ...args: any[]) => {
      const userInfo = await Vue.prototype.$magicLogin?.getUserInfo(...args);
      commit('saveUserInfo', userInfo);
      return userInfo;
    }),

    setStorage({ commit }: any, data: any) {
      commit('saveStorage', data);
    },

    getStorage({ state }: any, data: any) {
      if (typeof data === 'string') {
        return state.storage[data];
      }
      return state.storage;
    },
  },
});
